import { memo, useCallback } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import Tooltip from '@clds/tooltip';
import { isMobile } from 'utils/domUtils';
import FolderCard from '@cld/folder-card';
import FolderIcon from '../FolderIcon';
import bindActions, { types as ats } from '../../actions';
import FolderItemSkeleton from './FolderItemSkeleton';

const { SET_NAVIGATION_CURRENT_FOLDER, SET_FOLDER_SELECTION } = ats;

const Wrapper = styled.div`
  margin-left: ${(props) => props.theme.spacing.xl};

  span {
    line-height: 1.2;
  }
`;

const FolderItem = memo(({ title, kind, isLoading, id, path, driveId, actions, isSelected }) => {
  const onSelection = useCallback(
    (e) => {
      actions[SET_FOLDER_SELECTION]({
        id,
        e,
      });
    },
    [actions, id]
  );

  const goToFolder = useCallback(() => {
    actions[SET_NAVIGATION_CURRENT_FOLDER]({
      id,
      path,
      kind,
      driveId,
    });
  }, [kind, driveId, id, path, actions]);

  const onMobile = isMobile();

  const eventsProps = {
    onClick: onMobile ? goToFolder : onSelection,
    onDoubleClick: onMobile ? undefined : goToFolder,
  };

  return (
    <Wrapper>
      <FolderCard selected={isSelected} size="md" {...eventsProps}>
        {isLoading ? (
          <FolderItemSkeleton />
        ) : (
          <>
            <FolderIcon kind={kind} variant="contrastLow" size={'xl'} />
            <Tooltip title={title} maxWidth="md">
              <Tooltip.OverflowTrigger data-test="folder-item-title">{title}</Tooltip.OverflowTrigger>
            </Tooltip>
          </>
        )}
      </FolderCard>
    </Wrapper>
  );
});

export default connect(null, (dispatch) => ({
  actions: bindActions(dispatch),
}))(FolderItem);
